import { render, staticRenderFns } from "./addDynamic.vue?vue&type=template&id=a72c8764&scoped=true&"
import script from "./addDynamic.vue?vue&type=script&lang=js&"
export * from "./addDynamic.vue?vue&type=script&lang=js&"
import style0 from "./addDynamic.vue?vue&type=style&index=0&id=a72c8764&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a72c8764",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\demoAdmin\\chuangyueBlockchaimAdmin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a72c8764')) {
      api.createRecord('a72c8764', component.options)
    } else {
      api.reload('a72c8764', component.options)
    }
    module.hot.accept("./addDynamic.vue?vue&type=template&id=a72c8764&scoped=true&", function () {
      api.rerender('a72c8764', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dynamic/topManagement/topManagementHome/components/addDynamic.vue"
export default component.exports